/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Infragraph Service
 * APIs for managing Infragraph.
 *
 * The version of the OpenAPI document: 2025-05-07
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Comparator is a type that allows users to compare propertyName and value when filtering for a specific value.
 * @export
 * @enum {string}
 */
export var HashicorpCloudInfragraph20250507Comparator;
(function (HashicorpCloudInfragraph20250507Comparator) {
    HashicorpCloudInfragraph20250507Comparator["UNSPECIFIED"] = "COMPARATOR_UNSPECIFIED";
    HashicorpCloudInfragraph20250507Comparator["EQUAL"] = "COMPARATOR_EQUAL";
    HashicorpCloudInfragraph20250507Comparator["NOTEQUAL"] = "COMPARATOR_NOT_EQUAL";
    HashicorpCloudInfragraph20250507Comparator["GREATERTHAN"] = "COMPARATOR_GREATER_THAN";
    HashicorpCloudInfragraph20250507Comparator["LESSTHAN"] = "COMPARATOR_LESS_THAN";
    HashicorpCloudInfragraph20250507Comparator["GREATERTHANOREQUAL"] = "COMPARATOR_GREATER_THAN_OR_EQUAL";
    HashicorpCloudInfragraph20250507Comparator["LESSTHANOREQUAL"] = "COMPARATOR_LESS_THAN_OR_EQUAL";
})(HashicorpCloudInfragraph20250507Comparator || (HashicorpCloudInfragraph20250507Comparator = {}));
export function HashicorpCloudInfragraph20250507ComparatorFromJSON(json) {
    return HashicorpCloudInfragraph20250507ComparatorFromJSONTyped(json, false);
}
export function HashicorpCloudInfragraph20250507ComparatorFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function HashicorpCloudInfragraph20250507ComparatorToJSON(value) {
    return value;
}
